import React, { useState, useEffect, FC } from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import styled from "@emotion/styled";
import {TransitionProps} from "@mui/material/transitions";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.01)',
        backdropFilter: 'blur(2px)',
    },
    '& .MuiDialog-container': {
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(0, 0, 0, 0.01)',
        '& .MuiPaper-root': {
            margin: '60px 0 0 auto',
            backgroundColor: '#DAF4C8',
            color: 'black',
            borderLeft: '8px solid #6BD425',
            borderRadius: '8px 0px 0px 8px;',
        },
    },
}));

const StyledDialogTitle = styled('div')({
    backgroundColor: '#DAF4C8',
    color: 'black',
    padding: '24px 40px 10px 40px',
    fontSize: '18px',
    fontWeight: 800,
});

const StyledDialogContent = styled('div')({
    fontSize: '16px',
    fontWeight: 600,
    padding: '0 40px 24px 40px',
    backgroundColor: '#DAF4C8',
});

interface UseSuccessModalReturn {
    showSuccessModal: (title: string, message: string, onCloseCallback?: () => void) => void;
    SuccessModal: FC;
}

const useSuccessModal = (): UseSuccessModalReturn => {
    const [open, setOpen] = useState<boolean>(false);
    const [successTitle, setSuccessTitle] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [onClose, setOnClose] = useState<() => void>();

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (open) {
            timer = setTimeout(() => {
                setOpen(false);
                if (onClose) {
                    onClose();
                    setOnClose(undefined);
                }
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [open, onClose]);

    const showSuccessModal = (title: string, message: string, onCloseCallback?: () => void): void => {
        setSuccessTitle(title);
        setSuccessMessage(message);
        setOpen(true);
        if (onCloseCallback) setOnClose(() => onCloseCallback);
    };

    const handleClose = () => {
        setOpen(false);
        if (onClose) {
            onClose();
            setOnClose(undefined);
        }
    };
    const SuccessModal: FC = () => (
        <StyledDialog
            TransitionComponent={Transition}
            keepMounted
            open={open}
            onClose={handleClose}
        >
            <StyledDialogTitle>{successTitle}</StyledDialogTitle>
            <StyledDialogContent>
                {successMessage}
            </StyledDialogContent>
        </StyledDialog>
    );

    return { showSuccessModal, SuccessModal };
};

export default useSuccessModal;
